import { render } from "./AllBuyAndSell.vue?vue&type=template&id=046c20e6&scoped=true"
import script from "./AllBuyAndSell.vue?vue&type=script&lang=js"
export * from "./AllBuyAndSell.vue?vue&type=script&lang=js"

import "./AllBuyAndSell.vue?vue&type=style&index=0&id=046c20e6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046c20e6"]])

export default __exports__